import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ToastModule } from '@app/services';

@NgModule({
  imports: [ToastModule.forRoot()],
})
export class CoreServicesModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreServicesModule) {
    if (parentModule) {
      throw new Error('CoreServicesModule has already been loaded. Import modules in the AppModule only.');
    }
  }
}
